import { render, staticRenderFns } from "./VehicleReviewView.vue?vue&type=template&id=3a6eb696&"
import script from "./VehicleReviewView.vue?vue&type=script&lang=js&"
export * from "./VehicleReviewView.vue?vue&type=script&lang=js&"
import style0 from "./VehicleReviewView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports